export const CHART = {
  ANALOG: 0,
  DIGITAL: 1,
}